export type TrailerType =
    | 'Single'
    | 'Decker'
    | 'Handball'
    | 'Specialised'
    | 'Van'
    | 'Internal'
    | 'Vet'
    | 'Unknown';

export const StackUpLabel = 'Stack-Up';
export const DeTopLabel = 'De-Top';
